import React, { useEffect, useState } from 'react'
import { InfoWindow, Marker } from '@react-google-maps/api'
import {
  Body,
  LinkText,
} from 'shared-global-ec-uikit/components/dist/react/esm'
import getConstants from '../../constants'
import './styles.css'

export type Props = {
  store: Components.Schemas.StoreList
  getDirectionsLabel: string
  kmAwayLabel: string
  handleStoreSelect?: (store: Components.Schemas.StoreList) => void
  handleMarkerClick?: (storeId: number) => void
  selectedMarker?: number | null
  location: any
}

const MapMarker = ({
  store,
  handleStoreSelect,
  handleMarkerClick,
  location,
  selectedMarker,
}: Props) => {
  const { REACT_APP_ASSET_BASE_URL: ASSET_BASE_URL } = process.env
  const { BRAND, MARKER_SUFFIX } = getConstants()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!(selectedMarker === store.id)) setIsOpen(false)
  }, [selectedMarker])

  const icon = {
    url: `${ASSET_BASE_URL}/${MARKER_SUFFIX[BRAND]}`,
    scaledSize: new window.google.maps.Size(31, 37),
  }

  return (
    <Marker
      onClick={() => {
        setIsOpen(!isOpen)
        if (handleMarkerClick) handleMarkerClick(store.id)
      }}
      position={location}
      icon={icon}
    >
      {isOpen ? (
        <InfoWindow
          onCloseClick={() => {
            setIsOpen(false)
          }}
        >
          <>
            <LinkText
              element="button"
              variant="standalone"
              onClick={() => {
                setIsOpen(false)
                if (handleStoreSelect) handleStoreSelect(store)
              }}
              className="fr-ec-mb-spacing-04"
            >
              <div className="mb1">{store.name}</div>
            </LinkText>
            <Body element="h4">
              <LinkText
                element="a"
                href={`tel:${store.phone}`}
                variant="standalone"
                onClick={() => {}}
                emphasize={false}
              >
                {store.phone}
              </LinkText>
            </Body>
          </>
        </InfoWindow>
      ) : null}
    </Marker>
  )
}

export default MapMarker
